import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import IconButton, { type IconButtonProps } from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import React, { useCallback, useState } from 'react'

import TakePaymentsDialog from 'components/billing/groups/payment/take-payments'
import T from 'T'

interface TakePaymentIconButtonProps extends Omit<IconButtonProps, 'onClick'> {
  accountId: string
  from?: string
}

const TakePaymentIconButton = ({ accountId, from = 'customerDetails', size = 'medium', ...rest }: TakePaymentIconButtonProps) => {
  const [isOpenTakePaymentsDialog, setIsOpenTakePaymentsDialog] = useState(false)

  const handleToggleTakePaymentsDialog = useCallback(() => setIsOpenTakePaymentsDialog(prev => !prev), [])

  return (
    <>
      <Tooltip arrow title={T.TAKE_PAYMENT}>
        <IconButton size={size} {...rest} onClick={handleToggleTakePaymentsDialog}>
          <AttachMoneyIcon />
        </IconButton>
      </Tooltip>
      {isOpenTakePaymentsDialog && (
        <TakePaymentsDialog
          initialAccount={{ id: accountId, from }}
          isOpen={isOpenTakePaymentsDialog}
          onClose={handleToggleTakePaymentsDialog}
        />
      )}
    </>
  )
}

export default TakePaymentIconButton
